export default () => {
  if (global.ENABLE_APPDYNAMICS === 'YES') {
    if (!global.APPDYNAMICS_APPLICATION_KEY) {
      throw new Error('ENABLE_APPDYNAMICS is \'YES\' but APPDYNAMICS_APPLICATION_KEY is not specified');
    }
    return {
      isEnabled: true,
      applicationKey: global.APPDYNAMICS_APPLICATION_KEY,
    };
  } else return {
    isEnabled: false,
  };
};
